
import Vue from "vue"
import Router from "vue-router"

import Home from "./views/Home.vue"
import Login from "./views/auth/Login.vue"
import Verify from "./views/auth/Verify.vue"
import Profile from "./views/auth/Profile.vue"
import Captcha from "./views/auth/Captcha.vue"
import Dashboard from "./views/Dashboard.vue"
import LPUList from "./views/catalogs/LpuList.vue"
import LPUItem from "./views/catalogs/LpuItem.vue"
import LPUItemAdd from "./views/catalogs/LpuItemAdd.vue"
import Settings from "./views/Settings.vue"
import NotFound from "./views/NotFound.vue"
import UserList from "./views/UserList.vue"

import { AuthGuard } from "./utils"

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Главная",
      component: Home
    },
    {
      path: "/login",
      name: "Войти",
      component: Login
    },
    {
      path: "/verify",
      name: "Подтверждение",
      component: Verify
    },
    {
      path: "/profile",
      name: "Профиль",
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: "/captcha",
      name: "Капча",
      component: Captcha
    },
    {
      path: "/settings",
      name: "Настройки",
      component: Settings,
      beforeEnter: AuthGuard
    },
    {
      path: "/dashboard",
      name: "Панель мониторинга",
      component: Dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: "/catalog-lpu",
      name: "Справочник ЛПУ",
      component: LPUList,
      beforeEnter: AuthGuard
    },
    {
      path: "/user-list",
      name: "Список пользователей",
      component: UserList,
      beforeEnter: AuthGuard
    },
    {
      path: "/catalog-lpu/:id",
      props: true,
      component: LPUItem,
      beforeEnter: AuthGuard
    },
    {
      path: "/catalog-lpu-add",
      component: LPUItemAdd,
      beforeEnter: AuthGuard
    },
    {
      path: "/404",
      component: NotFound
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});
